<script lang="ts">
    import type {AuthorityDetailReactivePageData, AuthorityDetailStaticPageData} from '../types';
    import {exists} from 'shared/utils/custom-utils';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpCover from '../../kp-cover/KpCover.svelte';
    import KpCustomParagraph from 'shared/value-editors/internal/editors/search-or-edit/templates/KpCustomParagraph.svelte';

    const pageContext = getPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

{#if exists(model.record.cover) || (exists(model.paragraph) && model.paragraph)}
    <div class="main-details detail-blok-main authority-detail-blok-main">
        <!-- Cover -->
        {#if exists(model.record.cover)}
            <div class="cover-container">
                <KpCover record="{model.record}"
                         target="cover"
                         fillTo="width"
                         canManageCover="{model.filesManageable}"
                         mainRecordDetailCover/>
            </div>
        {/if}

        <!-- Record management -->
        <div class="custom-paragraph-container">
            <!-- Custom paragraph -->
            <KpCustomParagraph content="{model.paragraph}"/>
        </div>
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .main-details {
        margin: 0;

        .cover-container {
            float: right;
            margin: 0 0 20px 20px;
            width: 264px;
        }
    }
</style>